/* unplugin-vue-components disabled */import { render } from "./xLayoutHeader.vue?vue&type=template&id=5bb34838"
import script from "./xLayoutHeader.vue?vue&type=script&lang=jsx"
export * from "./xLayoutHeader.vue?vue&type=script&lang=jsx"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__